<template>
    <div class="brand-logo max-w-full"
        :class="[
            isPublic? 'bg-left lg:bg-left lg:bg-[center-left] bg-[center-left]': 'bg-center'
        ]">
    </div>
</template>
<script lang="ts" setup>
const props = withDefaults(defineProps<{
    isPublic?: boolean;
}>(), {
    isPublic: false,
})
</script>
<style scoped>
.brand-logo {
    min-width: 42px;
    min-height: 26px;
    background-image: var(--core-logo);
    background-size: contain;
    background-repeat: no-repeat;
    /* background-position: center; */
}
</style>
